import { createAsyncThunk } from '@reduxjs/toolkit';
import PropertiesResource from 'api/service/PropertiesResource';

export const listAllAutocompleteProperties = createAsyncThunk(
  'properties/listAllAutocompleteProperties',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { query = '' } = initialData || {};
    const params = { orderBy: 'name', access: 'Write', size: 15, offset: 0, query: query || '' };

    const { status, data } = await propertiesResource.search(params);

    if (status === 200) {
      return { data: data || [], offset: 15 };
    }
    return rejectWithValue('Properties not found');
  }
);

export const listAllAutocompletePropertiesNext = createAsyncThunk(
  'properties/listAllAutocompletePropertiesNext',
  async (initialData, { rejectWithValue }) => {
    const propertiesResource = new PropertiesResource();
    const { offset = 0 } = initialData || {};
    const { query = '' } = initialData || {};
    const params = { orderBy: 'name', access: 'Write', size: 15, offset: offset || 0, ...(query ? { query } : {}) };

    const { status, data } = await propertiesResource.search(params);

    if (status === 200) {
      return { data: data || [], offset: offset + 15 };
    }
    return rejectWithValue('Properties not found');
  }
);
